import React from "react";
import { Card, CircularProgress } from "@mui/material";
import { FaRegCopy } from "react-icons/fa";
const AvailablePointsMobileView = ({ loyaltyInfo, isCouponcodeDisabled, couponCode, handleSubmitCouponPoints, handleCoupons, couponPoints, isCouponpointsDisable, copied, handleCopyClick, woocommerceCoupon, woocommerceCouponError, isLoder, isWcoupon }) => {
  return (
    <div className="container3">
      <hr style={{ width: "100%", height: "1px", border: "none", backgroundColor: "#000000", margin: "5px 0", marginTop: "20px" }} />

      <p style={{ fontWeight: 500, fontSize: "15px" }}>Redeem your loyalty points here</p>

      <Card sx={{ width: "64vw", borderRadius: 1, height: "auto", padding: 2, marginLeft: 0.5 }} className="container2">
        <div className="available-balance-container">
          <div>
            <p className="availblepointsmarging">Available Balance:</p>
          </div>
          <div>
            <p className="availblepointsmarging">{loyaltyInfo?.points_available}</p>
          </div>
        </div>
      </Card>
      <form onSubmit={handleSubmitCouponPoints}>
        <div className="points-redem-container1">
          <input className="custom-textfield" id="coupon-points" label="Coupon Points" value={couponPoints} onChange={handleCoupons} disabled={isCouponcodeDisabled || couponCode || isCouponpointsDisable || isWcoupon} />
          <button type="submit" disabled={isCouponpointsDisable || couponCode || isCouponpointsDisable} className={isCouponpointsDisable || isCouponcodeDisabled || couponCode ? "custom-button2" : "custom-button1"}>
            Credit Redemption
          </button>
        </div>
      </form>
      {isLoder && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px", marginLeft: "50px" }}>
          <CircularProgress sx={{ color: "var(--primary-color)" }} />
        </div>
      )}
      {woocommerceCoupon && (
        <div className="custom-textfield2">
          <p>{woocommerceCoupon}</p>
          {!copied ? <FaRegCopy onClick={handleCopyClick} style={{ marginTop: "0px", marginLeft: "30px", cursor: "pointer" }} /> : <p style={{ marginTop: "15px", marginLeft: "30px", color: "green" }}>Copied!</p>}
        </div>
      )}

      {woocommerceCouponError && <p className="error-msg">{woocommerceCouponError}</p>}
      {isWcoupon ? (
        <h3 className="mobilescreen-text">
          <span style={{ color: "var(--primary-color)" }}>Note: </span>Once you've redeemed your points or coupons, get the code and input it in the coupon field before completing your purchase to receive the discount.
        </h3>
      ) : (
        ""
      )}
    </div>
  );
};

export default AvailablePointsMobileView;
